<template>
  <div class="auth-card" v-if="authTitle && authText">
    <div class="auth-header">
      <div class="auth-header__logo">
        <img :src="`https://cdn.crezu.net/game_flow/src/assets/img/partners/${partner}.svg`" alt="logo" />
        <span>{{ uppercaseFirstLetter(partner) }}</span>
      </div>
      <div class="auth-header__arrows">
        <svg v-for="i in 3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 5 8">
          <path d="M4.35355 4.35355C4.54882 4.15829 4.54882 3.84171 4.35355 3.64645L1.17157 0.464466C0.976311 0.269204 0.659728 0.269204 0.464466 0.464466C0.269204 0.659728 0.269204 0.976311 0.464466 1.17157L3.29289 4L0.464466 6.82843C0.269204 7.02369 0.269204 7.34027 0.464466 7.53553C0.659728 7.7308 0.976311 7.7308 1.17157 7.53553L4.35355 4.35355ZM3 4.5H4V3.5H3V4.5Z" fill="#272D2E"/>
        </svg>
      </div>
      <div class="auth-header__logo">
        <img src="@/assets/img/partners/Crezu.svg" alt="logo" />
        <span>Crezu</span>
      </div>
    </div>
    <div class="auth-card__line"></div>
    <div class="auth-text">
      <div class="auth-text__title">{{ authTitle }}</div>
      <div class="auth-text__text">{{ authText }}</div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getURLParameter } from '../../utils/common'

export default {
  name: 'AuthText',
  props: {
    title: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState({
      authTitle: (state, getters) => {
        const name = getters.getFieldValue('name')
        console.log('NAME', name)
        return (state.config.params.authTitle || '').replace('{{name}}', name)
      },
      authText: state => state.config.params.authText,
    }),
    partner: () => getURLParameter('welcome')
  },
  methods: {
    uppercaseFirstLetter (string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    }
  },
  beforeMount () {
    const header = document.querySelector('.form-header')
    if (header) header.style.display = 'none'
    this.$store.commit('UPDATE_PERCENTS', 30)
  },
  beforeDestroy () {
    const header = document.querySelector('.form-header')
    if (header) header.style.display = 'block'
  }
}
</script>

<style lang="scss" scoped>
  .auth-card {
    display: flex;
    padding: 20px;
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
    align-self: stretch;
    border-radius: 6px;
    background: #AAF0DB;
    margin: 0 auto 20px;
    max-width: var(--max-width);
    text-align: left;

    @media (min-width: 768px) {
      margin: 0 auto 30px;
    }

    .auth-header {
      display: flex;
      align-items: center;
      gap: 15px;
      align-self: stretch;

      &__logo {
        display: flex;
        align-items: center;
        gap: 5px;

        img {
          width: 30px;
          height: 30px;
        }

        span {
          color: #272D2E;
          font-size: 16px;
          font-style: normal;
          font-weight: 700;
          line-height: 24px;
        }
      }

      &__arrows {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 10px;

        svg {
          height: 8px;
          animation: arrowAnimation 1.5s infinite;
          transition: 0.5s ease;
        }

        svg:nth-child(2) {
          animation-delay: 0.5s;
        }

        svg:nth-child(3) {
          animation-delay: 1s;
        }

        @keyframes arrowAnimation {
          0% {
            opacity: 1;
          }
          20% {
            opacity: 0.75;
          }
          40% {
            opacity: 0.6;
          }
          60% {
            opacity: 0.45;
          }
          80% {
            opacity: 0.3;
          }
          100% {
            opacity: 0.15;
          }
        }
      }
    }

    &__line {
      width: 100%;
      height: 1px;
      background: rgba(0, 0, 0, 0.15);
    }

    .auth-text {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 10px;
      align-self: stretch;

      &__title {
        color: #272D2E;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 24px;
      }

      &__text {
        color: #272D2E;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 21px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/assetComponents/AuthText.vue